module.exports = __webpack_public_path__ + "images/banners/kaitori_bonus_campaign/banner_campaign202007_medium_8f4e67e2742aae91f3757a7ecbdb79b1.jpg";